import snarkdown from 'snarkdown';

/**
 * Renders question text as markdown (snarkdown). Custom rule: the deprecated
 * `,, ` separator is treated as a hard line break for backward compatibility
 * with legacy question text. Each segment is rendered as markdown independently
 * and joined with `<br />`, so line breaks are deterministic regardless of
 * snarkdown's own newline handling. Returns an HTML string.
 */
export function formatQuestionMarkdown(text: string | string[]): string {
  if (!text) return '';

  const segments = Array.isArray(text)    ? text
    : text.split(',, ').map((segment) => segment.trim());

  return segments
    .map((segment) => snarkdown(segment))
    .join('<br />');
}
